export default "__VITE_ASSET__01edc3fd__"